import * as commonScripts from '../common'
import Glide from '@glidejs/glide'

const cmpAutomatedArticleCarousel = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    commonScripts.util.inheritPermalink(element)
    // If not in edit mode, then initialize the carousel
    if (!commonScripts.util.isEditMode()) {
      const carouselId = _.component.getAttribute('data-carousel-id')
      const carouselDiv = _.component.querySelector(
        '#' + carouselId + ' .glide'
      )
      const slidesAmount = carouselDiv.querySelectorAll('.glide__slide').length

      if (carouselDiv) {
        const options = {}
        options.rewind = false
        options.perView = 3
        options.bound = true
        options.gap = 30
        options.breakpoints = {
          767: {
            perView: 1
          }
        }
        const glide = new Glide(carouselDiv, options)

        glide.mount()

        glide.on('build.after', function () {
          // show arrows on desktop when 4 or more slides.
          if (slidesAmount > 3) {
            carouselDiv
              .querySelector('.glide__arrows.desktop')
              .classList.add('d-sm-block')
          }
        })

        let currentSlide = null
        glide.on('move.after', function () {
          // prevents re-render when click on any part of carousel.
          if (currentSlide === glide.index) return
          currentSlide = glide.index

          const firstSlide = 0
          const mobile = 1
          const desktop = 2
          const lastSlideMobile = slidesAmount - 1 // -1 since glide index starts at 0.
          const lastSlideDesktop = slidesAmount - 3 // -3 since desktop displays 3 slides at the same time.

          const arrowLeftMobile = carouselDiv.querySelector(
            '.mobile .glide__arrow--left'
          )
          const arrowRightMobile = carouselDiv.querySelector(
            '.mobile .glide__arrow--right'
          )

          const arrowLeftDesktop = carouselDiv.querySelector(
            '.desktop .glide__arrow--left'
          )
          const arrowRightDesktop = carouselDiv.querySelector(
            '.desktop .glide__arrow--right'
          )

          handleArrows(
            arrowLeftMobile,
            arrowRightMobile,
            currentSlide,
            firstSlide,
            lastSlideMobile,slidesAmount,mobile
          )
          handleArrows(
            arrowLeftDesktop,
            arrowRightDesktop,
            currentSlide,
            firstSlide,
            lastSlideDesktop,slidesAmount,desktop
          )
        })
      }
    }
    function handleArrows (
      arrowLeft,
      arrowRight,
      currentSlide,
      firstSlide,
      lastSlide,slides,deviceType
    ) {
      if (currentSlide === firstSlide) {
        disable(arrowLeft)
        enable(arrowRight)
      }
      if (currentSlide > firstSlide && currentSlide < lastSlide) {
        enable(arrowLeft)
        enable(arrowRight)
      }
      if (currentSlide === lastSlide) {
        enable(arrowLeft)
        disable(arrowRight)
      }
      if(deviceType === 2){
        if (slides <= 3) {
          arrowLeft.style.display = "none"
          arrowRight.style.display = "none"
        }
      }
      if(deviceType === 1){
        if (slides == 1) {
          arrowLeft.style.display = "none"
          arrowRight.style.display = "none"
        }
      }
    }
    function disable (arrow) {
      arrow.disabled = true
    }
    function enable (arrow) {
      arrow.disabled = false
    }
  }
}

export default cmpAutomatedArticleCarousel
